<template>
  <el-container>
  <el-header>
    <el-col :span="24">
      <span>{{ $t('informe.sile')}}</span>
    </el-col>
  </el-header>
  <el-main>
  <el-form :label-position="labelPosition">
  <el-row :gutter="4">
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <el-form-item :label="$t('informe.initialDate')">
        <el-date-picker v-model="fecha_inicial" format="yyyy/MM/dd"></el-date-picker>
      </el-form-item>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <el-form-item :label="$t('informe.endDate')">
        <el-date-picker v-model="fecha_final" format="yyyy/MM/dd"></el-date-picker>
      </el-form-item>
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="24">
      <el-button type="primary" @click="obtenerDatos()">{{ $t('informe.process')}}</el-button>
    </el-col>
  </el-row>
  </el-form>
  <el-row>
    <el-col>
  <el-table
    :data="tableData"
    width="100%"
    height="600px"
    stripe
    v-loading="loading"
  >
  <el-table-column
      :label="$t('item')"
      type="index"
      width="50"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_fecharecepcion')"
      prop="repo_fecharecepcion"
      width="110"
    >
    <template slot-scope="scope">
      <span>{{ $moment(scope.row.repo_fecharecepcion).format('YYYY-MM-DD') }}</span>
    </template>
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_horarecepcion')"
      prop="repo_fecharecepcion_time"
      width="110"
    >
      <template slot-scope="scope">
        <span>{{ $moment(scope.row.repo_fecharecepcion_time).format('HH:mm') }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('informe.barr_descripcion')"
      prop="barr_descripcion"
      width="200"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.odt')"
      prop="ortr_consecutivo"
      width="80"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.orig_descripcion')"
      prop="orig_descripcion"
      width="200"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_fechasolucion')"
      prop="repo_fechasolucion"
      width="110"
    >
    <template slot-scope="scope">
      <span>{{ $moment(scope.row.repo_fechasolucion).format('YYYY-MM-DD') }}</span>
    </template>
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_horasolucion')"
      prop="repo_horasolucion"
      width="110"
    >
      <template slot-scope="scope">
        <span>{{ $moment(scope.row.repo_horasolucion).format('HH:mm') }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_horas')"
      prop="horas"
      width="100"
    >
      <template slot-scope="scope">
        <span>{{$toHHMMSS(scope.row.horas) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_direccion')"
      prop="repo_direccion"
      width="250"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.acti_descripcion')"
      prop="acti_descripcion"
      width="150"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.aap_potencia')"
      prop="aap_potencia"
      width="100"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.cantidad')"
      prop="cantidad"
      width="100"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_telefono')"
      prop="repo_telefono"
      width="100"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_telefono')"
      prop="aap_potencia"
      width="100"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_nombre')"
      prop="repo_nombre"
      width="200"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_prioridad')"
      prop="repo_prioridad"
      width="100"
    >
    </el-table-column>
    <el-table-column
      :label="$t('informe.repo_descripcion')"
      prop="repo_descripcion"
      width="300"
    >
    </el-table-column>
  </el-table>
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="24">
      <img :title="$t('xls')" @click="exportarXls()" style="width:32px; height: 36px; cursor: pointer;" :src="require('@/assets/xls.png')"/>
    </el-col>
  </el-row>
  </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
import { informe_siap_informe_luminarias_encendidas, informe_siap_informe_luminarias_encendidas_xlsx } from '@/api/informe'
export default {
  data () {
    return {
      labelPosition: 'top',
      fecha_inicial: new Date(),
      fecha_final: new Date(),
      tableData: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'empresa',
      'usuario'
    ])
  },
  methods: {
    obtenerDatos () {
      this.loading = true
      informe_siap_informe_luminarias_encendidas(this.fecha_inicial.getTime(), this.fecha_final.getTime()).then(response => {
        this.loading = false
        this.tableData = response.data
      }).catch(error => {
        this.loading = false
        console.log('Error Retiro: ' + error)
      })
    },
    exportarXls () {
      const loading = this.$loading({
        lock: true,
        text: 'Generando Archivo...',
        spinner: 'el-icon-loading'
      })
      informe_siap_informe_luminarias_encendidas_xlsx(this.fecha_inicial.getTime(), this.fecha_final.getTime()).then(response => {
          const filename = response.headers['content-disposition'].split('filename=')[1]
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          loading.close()
          link.click()
        })
        .catch((error) => {
          loading.close()
          console.log('Error generando excel:', error)
        })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    }
  }
}
</script>
<style lang="scss" scoped>
.fa-icon {
  width: auto;
  height: 1em; /* or any other relative font sizes */

  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}
</style>
